import type { ReactNode } from 'react';
import { Status } from '@beyond-js/ui/react';

export type Tone = 'neutral' | 'success' | 'warning' | 'error' | 'info';

const tones = { neutral: 'neutral', success: 'success', warning: 'warning', error: 'danger', info: 'info' } as const;

/**
 * A state label: the family's status, a dot beside the text. The text carries the meaning; the color only
 * reinforces it.
 */
export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
	return <Status tone={tones[tone]} label={children} />;
}
